// axios
import axios from 'axios'
// const baseURL = 'http://localhost:4000/api/'   // Apple
// const baseURL = 'http://localhost:59842/api/'     // Windows
  const baseURL = 'https://dawleys-bcc-dosos.azurewebsites.net/api/'

export default axios.create({
  baseURL
  // You can add your headers here
})
 